export const server_error_label = {
  // MOBILE APP
  "q8fa.services.app.client.version.obsolete": "La versione dell'app è obsoleta, aggiorna per continuare.",
  // USER
  "q8fa.services.app.user.registrationFailed.genericError": "Errore generico durante la registrazione.",
  "q8fa.services.app.user.registrationFailed.userAlreadyExists": "Lo username inserito esiste già.",
  "q8fa.services.app.user.registrationFailed.licenseMaxAccountsExceeded": "Superato il limite massimo di account per licenza.",
  "q8fa.services.app.user.principal.invalid": "Dati utente non validi.",
  "q8fa.services.app.user.notFound": "Utente non trovato.",
  "q8fa.services.app.user.noAssociatedHierarchy": "Utente senza gerarchia associata.",
  "q8fa.services.app.user.profileType.notFound": "Tipo profilo utente non trovato.",
  "q8fa.services.app.user.unauthorized": "Accesso negato. Permessi insufficienti.",
  // GESTORE
  "q8fa.services.app.gestore.codicePayer.notValid": "Codice cliente gestore non valido.",
  "q8fa.services.app.gestore.notFound": "Gestore non trovato.",
  "q8fa.services.app.pin.notValid": "PIN non valido.",
  "q8fa.services.app.gestore.pv.notValid": "Codice punto vendita non valido per il gestore.",
  // CHECKLIST
  "q8fa.services.app.checklist.notModifiable": "Checklist non modificabile.",
  "q8fa.services.app.checklist.share.success": "Checklist condivisa con successo.",
  "q8fa.services.app.checklist.share.error": "Errore durante la condivisione della checklist.",
  "q8fa.services.app.checklist.unconfirmable": "Impossibile annullare la conferma della checklist.",
  // PV
  "q8fa.services.app.pv.notValid": "Punto vendita non valido.",
  // SURVEY
  "q8fa.services.app.survey.notFound": "Survey non trovata.",
  // Altri
  "api.user.notFound": "Utente non trovato"
};